import {
    useEffect,
    type FC
} from "react";
import {
    Platform
} from "react-native";
import type ICardTitleProps from "./type";
import stylesheet, {
    CARD_TITLE_SKELETON_WIDTH,
    getCardTitleVariant
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    CardPartContentProps
} from "../../type";
import {
    getCardChildrenText,
    getCardHiddenProps
} from "../../util";
import {
    getCardColors
} from "../../stylesheet";
import {
    withCardContext
} from "../../context";
import Skeleton from "../../../skeleton";
import Text from "../../../text";

const CardTitleContent: FC<CardPartContentProps<ICardTitleProps>> = ({
    customTheme: customThemeProp,
    headingLevel = 3,
    isMetric = false,
    children,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        registerPart,
        isLoading
    } = context;

    const currentColors = getCardColors({
        isDisabled: context.isDisabled,
        colors
    });

    const currentVariant = getCardTitleVariant({
        isMetric
    });

    const text = getCardChildrenText(children);

    const hiddenProps = getCardHiddenProps({
        isPressable: context.isPressable,
        text
    });

    const headingProps = Platform.OS === "web" ? {
        "aria-level": headingLevel
    } : {};

    useEffect(() => {
        if(isLoading) {
            return;
        }

        return registerPart("title", text);
    }, [
        registerPart,
        isLoading,
        text
    ]);

    if(isLoading) {
        return <Skeleton
            width={CARD_TITLE_SKELETON_WIDTH}
            typography={currentVariant}
            customTheme={customTheme}
            variant="text"
        />;
    }

    return <Text
        {...hiddenProps}
        {...headingProps}
        {...props}
        style={[
            style,
            isMetric ? stylesheet.metric : undefined
        ]}
        customColor={currentColors.titleColor}
        customTheme={customTheme}
        variant={currentVariant}
        id={context.titleID}
        role="heading"
    >
        {children}
    </Text>;
};
export default withCardContext("title", CardTitleContent);
